import type { FC } from 'react'

import NotFoundIcon from '@/assets/icons/icon-not-found.svg'
import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button'

interface Props {
  onAdd: () => void
}

export const ProspectsPlaceholder: FC<Props> = ({ onAdd }) => {
  return (
    <div className="flex h-[calc(100vh-72px)] flex-col items-center justify-center">
      <div className="flex max-w-[400px] flex-col items-center">
        <NotFoundIcon />
        <p className="text-title text-2xl font-semibold">No Prospects</p>
        <p className="text-secondary-400 mt-2 text-center text-sm">
          Add a prospect to keep track of their performance and create an
          analysis based on the platforms they&apos;re using
        </p>
        <Button
          onClick={onAdd}
          className="mt-4"
        >
          <PlusIcon />
          Add Prospect
        </Button>
      </div>
    </div>
  )
}
